import { render } from "./FormTextboxGroup.vue?vue&type=template&id=01a9cb5b"
import script from "./FormTextboxGroup.vue?vue&type=script&lang=js"
export * from "./FormTextboxGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__